import React, { useState } from "react";
import { Button, Modal } from "antd"; // Ensure this import is correct
import { ExclamationCircleFilled } from "@ant-design/icons";

type ConfirmModalsProps = {
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  text: string;
 
 
};
const ConfirmModals: React.FC<ConfirmModalsProps> = (props) => {
  return (
    <>
      <Modal
        title={
          <>
            <ExclamationCircleFilled
              style={{ marginRight: 8, color: "#faad14" }}
            />
            CONFIRM
          </>
        }
        open={props?.isModalOpen}
        onOk={props?.handleOk}
        onCancel={props?.handleCancel}
        // confirmLoading={props.isReferralLoading}
        okText="YES"
        cancelText="NO"
      >
        <p style={{ fontSize: "16px" }}>
          {props?.text}?
    
         
        </p>
      </Modal>
    </>
  );
};

export default ConfirmModals;
